export type DropProductCardGridColumns = 2 | 3 | 4;

const SUPPORTED_COLUMNS: DropProductCardGridColumns[] = [2, 3, 4];

const isSupportedColumns = (
	value: number
): value is DropProductCardGridColumns =>
	SUPPORTED_COLUMNS.includes(value as DropProductCardGridColumns);

export const getDropProductCardGridColumns = (
	desktopColumns: number | null | undefined,
	isCompact: boolean | null | undefined
): DropProductCardGridColumns => {
	if (
		typeof desktopColumns === 'number' &&
		isSupportedColumns(desktopColumns)
	) {
		return desktopColumns;
	}

	return isCompact ? 4 : 2;
};
